export const FILTER_FIELD_TEXTS = {
  callPeriod: {
    label: 'Период звонков',
  },
  notificationType: {
    label: 'Сценарий',
    placeholder: 'Выберите сценарий',
  },
  clinic: {
    label: 'Медицинская организация',
    placeholder: 'Выберите медицинскую организацию',
  },
  taskResult: {
    label: 'Результат задания',
    placeholder: 'Выберите результат',
  },
  taskStatus: {
    label: 'Статус задания',
    placeholder: 'Выберите статус задания',
  },
  attemptStatus: {
    label: 'Статус попытки',
    placeholder: 'Выберите статус попытки',
  },
  doctorSpecialization: {
    label: 'Специализация врача',
    placeholder: 'Выберите специализацию',
  },
  doctor: {
    label: 'ФИО врача',
    placeholder: 'Выберите врача',
  },
  batch: {
    label: 'Кампания',
    placeholder: 'Выберите кампанию',
  },
  surveyType: {
    label: 'Сценарий анкеты',
    placeholder: 'Выберите сценарий анкеты',
  },
  surveyTemplate: {
    label: 'Шаблон анкеты',
    placeholder: 'Выберите шаблон анкеты',
  },
} as const;
